if (!customElements.get('pdp-ingredients-slider')) {
  class PdpIngredientsSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-slider-track]');
      this.prevBtn = this.querySelector('[data-slider-prev]');
      this.nextBtn = this.querySelector('[data-slider-next]');
      this.nav = this.querySelector('[data-slider-nav]');

      if (!this.track) return;

      this.handleScroll = this.handleScroll.bind(this);
      this.track.addEventListener('scroll', this.handleScroll, { passive: true });
      this.prevBtn?.addEventListener('click', () => this.slide(-1));
      this.nextBtn?.addEventListener('click', () => this.slide(1));

      this.updateButtons();
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.handleScroll);
    }

    slide(direction) {
      const card = this.track.querySelector('.section-pdp-ingredients__card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      const scrollAmount = card.offsetWidth + gap;
      this.track.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
    }

    handleScroll() {
      if (this.scrollRaf) cancelAnimationFrame(this.scrollRaf);
      this.scrollRaf = requestAnimationFrame(() => this.updateButtons());
    }

    updateButtons() {
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const atStart = scrollLeft <= 1;
      const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;

      this.prevBtn?.toggleAttribute('disabled', atStart);
      this.nextBtn?.toggleAttribute('disabled', atEnd);

      if (scrollWidth <= clientWidth + 1) {
        this.nav?.classList.add('is-hidden');
      } else {
        this.nav?.classList.remove('is-hidden');
      }
    }
  }

  customElements.define('pdp-ingredients-slider', PdpIngredientsSlider);
}

if (!customElements.get('pdp-ingredients-modal')) {
  class PdpIngredientsModal extends HTMLElement {
    connectedCallback() {
      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      document.removeEventListener('keydown', this.handleKeydown);
    }

    handleClick(event) {
      const closeBtn = event.target.closest('[data-modal-close]');
      if (closeBtn) {
        const overlay = closeBtn.closest('[data-ingredient-modal]');
        if (overlay) this.close(overlay);
        return;
      }

      const trigger = event.target.closest('[data-ingredient-trigger]');
      if (trigger) {
        const card = trigger.closest('[data-ingredient-card]');
        const overlay = card?.querySelector('[data-ingredient-modal]');
        if (overlay) this.open(overlay);
        return;
      }

      const overlay = event.target.closest('[data-ingredient-modal]');
      if (overlay && event.target === overlay) {
        this.close(overlay);
      }
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && this.activeOverlay) {
        this.close(this.activeOverlay);
      }
    }

    open(overlay) {
      this.activeOverlay = overlay;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('pdp-ingredients-modal-open');
      document.addEventListener('keydown', this.handleKeydown);

      const closeBtn = overlay.querySelector('[data-modal-close]');
      closeBtn?.focus();
    }

    close(overlay) {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('pdp-ingredients-modal-open');
      document.removeEventListener('keydown', this.handleKeydown);
      this.activeOverlay = null;
    }
  }

  customElements.define('pdp-ingredients-modal', PdpIngredientsModal);
}
